import { phone } from './validators/phone';
import { exactLength } from './validators/exact_length';
import { minLength } from './validators/min_length';
import { maxLength } from './validators/max_length';
import { regular } from './validators/regular';
import { regularCondition } from './validators/regular_condition';
import { isbn } from './validators/isbn';
import { email } from './validators/email';
import { match } from './validators/match';
import { compareFields } from './validators/compare_fields';
import logger from '@main/externals/bss-package-logger/js/logger';
export var validators = {
    phone: phone,
    exact_length: exactLength,
    min_length: minLength,
    max_length: maxLength,
    regular: regular,
    regular_condition: regularCondition,
    isbn: isbn,
    email: email,
    match: match,
    compare_fields: compareFields,
};
var BSSPackageValidation = /** @class */ (function () {
    /**
     *
     * @param {Object} config - configuration object
     * @param {Object} toolbox - provides common libraries: jquery and lodash
     * @param {EventManager} eventManager
     * @param {jQuery} entityTemplate
     */
    function BSSPackageValidation(config, toolbox, eventManager, entityTemplate) {
        if (entityTemplate === void 0) { entityTemplate = null; }
        logger.info('PackageValidation => constructor | Params: ', config, toolbox, logger, eventManager);
        /**
         * @desc configuration Object
         * @type {object}
         * @private
         */
        this._config = config;
        /**
         * @desc toolbox provides common libraries: $ -jquery, _ - lodash
         * @type {Object}
         * @private
         */
        this._toolbox = toolbox;
        /**
         * @desc  eventManager object
         * @type {Object}
         */
        this._eventManager = eventManager;
        /**
         * @desc validation option object
         * @type {Object}
         */
        this._validationOpts = {
            validClass: 'is-valid',
            errorClass: 'is-invalid',
            ignore: ':hidden, .rule-interact-element-hidden',
            focusCleanup: false,
            showErrors: this._showErrors.bind(this),
            onfocusout: this._onFocusOut.bind(this),
            onkeyup: this._onKeyUp.bind(this),
            onclick: this._onClick.bind(this),
        };
        this.mainContext = entityTemplate
            ? function (args) {
                return entityTemplate.find(args);
            }
            : this._toolbox.$;
        /**
         * @desc form selector
         * @type {Object}
         * @private
         */
        this._formSelector = this.mainContext(this._config.validation.formSelector);
        this._validator = this._formSelector.validate(this._validationOpts);
        this._formSelectorFields = this._formSelector.find('input, textarea, select');
        //TODO ajaxValidation - Need rebuild ajaxValidation functionality for specific fields and on specific event.
        if (this._config.validation.ajaxValidation) {
            var self_1 = this;
            this._toolbox.$.each(this._formSelectorFields, function (index, element) {
                var data = self_1._formSelector.find(element).data();
                self_1._ajaxValidate(data, self_1._config.validation.url);
            });
        }
        if (this._formSelectorFields && this._formSelectorFields.length) {
            this.loadCustomMethods();
        }
    }
    /**
     * @desc ajaxValidate - ajax validation method
     * @param {Object} data object
     * @param {String} url
     * @private
     */
    BSSPackageValidation.prototype._ajaxValidate = function (data, url) {
        logger.info('PackageValidation: ' +
            this._config.componentId +
            ' => function : _ajaxValidate' +
            ' | Params: ', data, url);
        this._toolbox.$.ajax({
            dataType: 'json',
            type: 'POST',
            url: url,
            data: data,
            success: function (response) {
                if (response) {
                    this._formSelector.trigger('submit');
                    return false;
                }
                else {
                    this._toolbox.$.each(response, function (i, v) {
                        var msg = '<label class="error" for="' + i + '">' + v + '</label>';
                        var $formElements = this._formSelector.find('input[name="' + i + '"], select[name="' + i + '"]');
                        $formElements.addClass('error-message is-invalid').after(msg);
                        return false;
                    });
                }
            },
        });
    };
    /**
     * @desc isValid - public method for validate form.
     * @param triggerFields - option to trigger validation on all fields default set to trigger.
     * @param [checkAllFields=true] - status if all fields should be checked.
     * if so all fields are marked as invalid (for invalid form validation)
     * or remove is-invalid class from all fields (for valid form validation)
     * @returns {*}
     * @public
     */
    BSSPackageValidation.prototype.isValid = function (triggerFields, checkAllFields) {
        var _this = this;
        if (triggerFields === void 0) { triggerFields = true; }
        if (checkAllFields === void 0) { checkAllFields = true; }
        if (this.mainContext('.bss-error-message.is-invalid:visible').length > 0) {
            return false;
        }
        var toggleRequired = function ($elements, isRadio) {
            if (isRadio === void 0) { isRadio = false; }
            // unikalne nazwy dla grup radiobuttonów
            if (isRadio) {
                var names = [];
                var seen = new Set();
                for (var i = 0; i < $elements.length; i++) {
                    var name_1 = $elements.eq(i).attr('name');
                    if (!seen.has(name_1)) {
                        seen.add(name_1);
                        names.push(name_1);
                    }
                }
                for (var i = 0; i < names.length; i++) {
                    var name_2 = names[i];
                    var $group = _this._formSelector.find("input[type=\"radio\"][name=\"".concat(name_2, "\"]"));
                    $group.removeClass('filled');
                    var isHidden = $group.first().closest('.oa-form-row.hidden').length > 0;
                    var isChecked = $group.is(':checked');
                    var hasFilledClass = $group.hasClass('filled');
                    if (isHidden || isChecked || hasFilledClass) {
                        $group.removeAttr('required').addClass('filled');
                    }
                    else {
                        $group.attr('required', 'required');
                    }
                }
                return;
            }
            // inputy, selecty
            $elements.each(function () {
                var $el = $(this);
                var isHidden = $el.closest('.oa-form-row.hidden').length > 0;
                var hasValue = !!$el.val();
                var hasFilledClass = $el.hasClass('filled');
                if (isHidden || hasValue || hasFilledClass) {
                    $el.removeAttr('required').addClass('filled');
                }
                else {
                    $el.attr('required', 'required');
                }
            });
        };
        // 🔹 1. SELECTY income/expense (Type + Frequency)
        toggleRequired.call(this, this._formSelector.find('select[name^="incomeType"], select[name^="expenseType"], ' +
            'select[name^="incomeFrequency"], select[name^="expenseFrequency"]'));
        // 🔹 2. RADIO incomeNetOrGross / expenseNetOrGross
        toggleRequired.call(this, this._formSelector.find('input[type="radio"][name^="incomeNetOrGross"], ' +
            'input[type="radio"][name^="expenseNetOrGross"]'), true);
        // 🔹 3. INPUTY number: incomeAmount + expenseAmount
        toggleRequired.call(this, this._formSelector.find('input[type="number"][name^="incomeAmount"], ' +
            'input[type="number"][name^="expenseAmount"]'));
        // 🔹 4. WALIDACJA FORMULARZA
        var isValid = triggerFields
            ? this._formSelector.valid()
            : this._formSelector
                .validate({
                ignore: '.oa-form-row.hidden input, .oa-form-row.hidden select',
            })
                .checkForm();
        if (checkAllFields) {
            if (isValid) {
                this._formSelector.find('.is-invalid').removeClass('is-invalid');
            }
            else {
                this.validateElements({ isElement: false, status: isValid });
            }
        }
        return isValid;
    };
    /**
     * @desc loadCustomMethods - load custom validation methods
     * @public
     */
    BSSPackageValidation.prototype.loadCustomMethods = function () {
        logger.info('PackageValidation: ' +
            this._config.componentId +
            ' => function : loadCustomMethods');
        this._formSelectorFields = this._formSelector.find('input, textarea, select');
        var validatorMethods = this._toolbox._.keys(this._toolbox.$.validator.methods);
        var attributes = [];
        var self = this;
        this._toolbox.$.each(this._formSelectorFields, function (index, element) {
            var data = self._formSelector.find(element).data();
            self._toolbox.$.each(data, function (i) {
                var methodString = i.toLowerCase().substring(4);
                if (i.search('rule') !== -1 &&
                    self._toolbox._.indexOf(attributes, i) === -1 &&
                    self._toolbox._.indexOf(validatorMethods, methodString) === -1) {
                    var d = validators[methodString];
                    attributes.push(methodString);
                    self._addMethod(methodString, d);
                }
            });
        });
    };
    /**
     * @desc addMethod - add custom validation methods
     * @private
     */
    BSSPackageValidation.prototype._addMethod = function (methodName, method) {
        logger.info('PackageValidation: ' +
            this._config.componentId +
            ' => function : _addMethod' +
            ' | Params: ', methodName, method);
        this._toolbox.$.validator.addMethod(methodName, method);
    };
    /**
     * @desc _showErrors - show errors
     * @param {Object} errorMap object
     * @param {Object} errorList object
     * @emits {this._config.validation.throwEventOnError-$COMPONENT-ID'}
     * @emits {this._config.validation.throwEventOnSuccess-$COMPONENT-ID'}
     * @private
     */
    BSSPackageValidation.prototype._showErrors = function (errorMap, errorList) {
        logger.info('PackageValidation: ' +
            this._config.componentId +
            ' => function : _showErrors' +
            ' | Params: ', errorMap, errorList);
        var self = this;
        this._toolbox.$.each(errorList, function (index, errorElement) {
            var element = self._formSelector.find(errorElement.element);
            var errorSelector = element.data('error-' + errorElement.method);
            var errorElem = self._formSelector.find('#' + errorSelector);
            element.addClass(self._validationOpts.errorClass);
            if (self._config.validation.defaultErrors && errorElem.text === '') {
                errorElem.html(errorElement.message);
            }
            errorElem.addClass(self._validationOpts.errorClass);
        });
        if (errorList.length) {
            this._eventManager.publish(this._config.validation.throwEventOnError +
                this._config.entityInstanceId, 'bss-package-validation');
        }
        else {
            this._eventManager.publish(this._config.validation.throwEventOnSuccess +
                this._config.entityInstanceId, 'bss-package-validation');
        }
    };
    /**
     * Validate elements by element validity status or by param validity status
     * @param {{isElement: boolean, status: string}} config
     * isElement/status - if isElement is true, elements validation will be done based on single element validity.
     * If isElement is false - all elements validation will be done based on 'status' validity
     * @public
     */
    BSSPackageValidation.prototype.validateElements = function (_a) {
        var _this = this;
        var isElement = _a.isElement, status = _a.status;
        this._formSelectorFields.each(function (_index, el) {
            var $el = _this._toolbox.$(el);
            _this._validateElement($el, isElement ? $el.valid() : status);
        });
    };
    /**
     * Validate element and add error class if necessary
     * @param elem {jQuery}
     * @param isValid {boolean}
     * @private
     */
    BSSPackageValidation.prototype._validateElement = function (elem, isValid) {
        if (isValid === void 0) { isValid = elem.valid(); }
        var componentId = elem.data('validation-componentid');
        var $component = this._formSelector.find("#".concat(componentId));
        var invalidCLass = 'is-invalid';
        if (!isValid) {
            $component.addClass(invalidCLass);
        }
        else {
            $component.removeClass(invalidCLass);
        }
    };
    /**
     * @desc _onFocusOut - function on focus out
     * @param {Object} element object
     * @private
     */
    BSSPackageValidation.prototype._onFocusOut = function (element) {
        logger.info('PackageValidation: ' +
            this._config.componentId +
            ' => function : _onFocusOut' +
            ' | Params: ', element);
        var elem = this._formSelector.find(element);
        this._hideErrors(elem);
        this._validateElement(elem);
    };
    /**
       * @desc _onClick - Click on radiobuttons and checkboxes
       // TODO functionality in selects
       * @param {Object} element object
       * @private
       */
    BSSPackageValidation.prototype._onClick = function (element) {
        logger.info('PackageValidation: ' +
            this._config.componentId +
            ' => function : _onClick' +
            ' | Params: ', element);
        var includeKeys = ['checkbox', 'radio'];
        if (this._toolbox.$.inArray(element.type, includeKeys) === -1) {
            return;
        }
        var elem = this._formSelector.find(element);
        this._hideErrors(elem);
        this._validateElement(elem);
    };
    /**
     * @desc _onKeyUp - function on key up
     * Avoid revalidate the field when pressing one of the following keys
     * Shift       => 16
     * Ctrl        => 17
     * Alt         => 18
     * Caps lock   => 20
     * End         => 35
     * Home        => 36
     * Left arrow  => 37
     * Up arrow    => 38
     * Right arrow => 39
     * Down arrow  => 40
     * Insert      => 45
     * Num lock    => 144
     * AltGr key   => 225
     *
     * @param {Object} element object
     * @private
     */
    BSSPackageValidation.prototype._onKeyUp = function (element, event) {
        logger.info('PackageValidation: ' +
            this._config.componentId +
            ' => function : _onKeyUp' +
            ' | Params: ', element);
        var excludedKeys = [16, 17, 18, 20, 35, 36, 37, 38, 39, 40, 45, 144, 225];
        if (this._toolbox.$.inArray(event.keyCode, excludedKeys) !== -1) {
            return;
        }
        var elem = this._formSelector.find(element);
        this._hideErrors(elem);
        this._validateElement(elem);
    };
    /**
     * @desc _hideErrors - hide errors
     * @param {Object} element object
     * @private
     */
    BSSPackageValidation.prototype._hideErrors = function (elem) {
        logger.info('PackageValidation: ' +
            this._config.componentId +
            ' => function : _hideErrors' +
            ' | Params: ', elem);
        var dataSet = elem.data();
        for (var key in dataSet) {
            if (key.search('error') >= 0) {
                this._formSelector
                    .find('#' + dataSet[key])
                    .removeClass(this._validationOpts.errorClass);
            }
        }
        if (typeof this._config.validation.additionalHideErrors === 'function') {
            this._config.additionalHideErrors.bind(this)(elem);
        }
        elem.removeClass(this._validationOpts.errorClass);
    };
    /**
     * @desc destroys and call super method
     * @public
     * @override
     */
    BSSPackageValidation.prototype.destroy = function () {
        logger.info('PackageValidation: ' +
            this._config.componentId +
            ' => function : destroy');
        this._formSelector.destroy();
    };
    return BSSPackageValidation;
}());
export default BSSPackageValidation;
